<div class="page loading" *ngIf="spinner">
    <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
</div>